import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"shutter"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M16.5 12L14.25 16L9.75 16L7.5 12L9.76087 8L14.25 8L16.5 12Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7.5 12L9.76087 8M7.5 12L9.75 16M7.5 12C6.16749 9.62052 5.12035 7.75062 4.08037 5.89351M9.76087 8L14.25 8M9.76087 8L13.1173 2.06172M16.5 12L14.25 16M16.5 12L14.25 8M16.5 12L19.9285 18.095M14.25 16L9.75 16M14.25 16L10.9081 21.9411M9.75 16L2.83209 16M14.25 8C17.0005 8 18.7193 8 21.1679 8M13.1173 2.06172C12.7505 2.02094 12.3777 2 12 2C8.77643 2 5.9091 3.52529 4.08037 5.89351M13.1173 2.06172C16.733 2.46368 19.7669 4.79349 21.1679 8M4.08037 5.89351C2.77599 7.5827 2 9.70073 2 12C2 13.4222 2.29689 14.7751 2.83209 16M2.83209 16C4.23636 19.214 7.28122 21.5472 10.9081 21.9411M10.9081 21.9411C11.2667 21.98 11.631 22 12 22C15.2288 22 18.1001 20.4698 19.9285 18.095M19.9285 18.095C21.2275 16.4077 22 14.2941 22 12C22 10.5778 21.7031 9.22492 21.1679 8","strokeWidth":"props.strokeWidth"}}]}]};

const Shutter = Vue.extend<IconProps>({
  name: 'ShutterIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'shutter',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Shutter;
